import { createStandardAction } from 'typesafe-actions';
import { buildActions } from '../actionUtilities';
import {
  AccountRequestFor,
  CreateAchScheduledDepositRequest,
  CreateAchScheduledWithdrawalRequest,
  CreateCheckScheduledWithdrawalRequest,
  CreateWireScheduledWithdrawalRequest,
  ScheduledTransfer,
  ScheduledTransfersQuery,
  ScheduledTransfersResponse,
} from '@tradingblock/types';

const REQUEST_SCHEDULED_TRANSFERS = '@cashiering/scheduledTransfers/REQUEST';
const RECEIVE_SCHEDULED_TRANSFERS = '@cashiering/scheduledTransfers/RECEIVE';
const ERROR_SCHEDULED_TRANSFERS = '@cashiering/scheduledTransfers/ERROR';

const REQUEST_SCHEDULED_TRANSFER_DETAILS = '@cashiering/scheduledTransferDetails/REQUEST';
const RECEIVE_SCHEDULED_TRANSFER_DETAILS = '@cashiering/scheduledTransferDetails/RECEIVE';
const ERROR_SCHEDULED_TRANSFER_DETAILS = '@cashiering/scheduledTransferDetails/ERROR';

const REQUEST_CANCEL_SCHEDULED_TRANSFER = '@cashiering/cancelScheduledTransfer/REQUEST';
const RECEIVE_CANCEL_SCHEDULED_TRANSFER = '@cashiering/cancelScheduledTransfer/RECEIVE';
const ERROR_CANCEL_SCHEDULED_TRANSFER = '@cashiering/cancelScheduledTransfer/ERROR';

const REQUEST_UPDATE_SCHEDULED_TRANSFER = '@cashiering/updateScheduledTransfer/REQUEST';
const RECEIVE_UPDATE_SCHEDULED_TRANSFER = '@cashiering/updateScheduledTransfer/RECEIVE';
const ERROR_UPDATE_SCHEDULED_TRANSFER = '@cashiering/updateScheduledTransfer/ERROR';

const REQUEST_CREATE_ACH_SCHEDULED_DEPOSIT = '@cashiering/createScheduledAchDeposit/REQUEST';
const RECEIVE_CREATE_ACH_SCHEDULED_DEPOSIT = '@cashiering/createScheduledAchDeposit/RECEIVE';
const ERROR_CREATE_ACH_SCHEDULED_DEPOSIT = '@cashiering/createScheduledAchDeposit/ERROR';

const REQUEST_CREATE_ACH_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledAchWithdrawal/REQUEST';
const RECEIVE_CREATE_ACH_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledAchWithdrawal/RECEIVE';
const ERROR_CREATE_ACH_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledAchWithdrawal/ERROR';

const REQUEST_CREATE_WIRE_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledWireWithdrawal/REQUEST';
const RECEIVE_CREATE_WIRE_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledWireWithdrawal/RECEIVE';
const ERROR_CREATE_WIRE_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledWireWithdrawal/ERROR';

const REQUEST_CREATE_CHECK_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledCheckWithdrawal/REQUEST';
const RECEIVE_CREATE_CHECK_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledCheckWithdrawal/RECEIVE';
const ERROR_CREATE_CHECK_SCHEDULED_WITHDRAWAL = '@cashiering/createScheduledCheckWithdrawal/ERROR';

const [requestScheduledTransfers, receiveScheduledTransfers, errorScheduledTransfers] = buildActions({
  REQUEST: REQUEST_SCHEDULED_TRANSFERS,
  RECEIVE: RECEIVE_SCHEDULED_TRANSFERS,
  ERROR: ERROR_SCHEDULED_TRANSFERS,
})<AccountRequestFor<ScheduledTransfersQuery>, ScheduledTransfersResponse>();

const [requestScheduledTransferDetails, receiveScheduledTransferDetails, errorScheduledTransferDetails] = buildActions({
  REQUEST: REQUEST_SCHEDULED_TRANSFER_DETAILS,
  RECEIVE: RECEIVE_SCHEDULED_TRANSFER_DETAILS,
  ERROR: ERROR_SCHEDULED_TRANSFER_DETAILS,
})<AccountRequestFor<{ scheduleId: number }>, ScheduledTransfer>();

const [requestCancelScheduledTransfer, receiveCancelScheduledTransfer, errorCancelScheduledTransfer] = buildActions({
  REQUEST: REQUEST_CANCEL_SCHEDULED_TRANSFER,
  RECEIVE: RECEIVE_CANCEL_SCHEDULED_TRANSFER,
  ERROR: ERROR_CANCEL_SCHEDULED_TRANSFER,
})<AccountRequestFor<{ scheduleId: number }>, ScheduledTransfer>();

const [requestUpdateScheduledTransfer, receiveUpdateScheduledTransfer, errorUpdateScheduledTransfer] = buildActions({
  REQUEST: REQUEST_UPDATE_SCHEDULED_TRANSFER,
  RECEIVE: RECEIVE_UPDATE_SCHEDULED_TRANSFER,
  ERROR: ERROR_UPDATE_SCHEDULED_TRANSFER,
})<AccountRequestFor<{ scheduleId: number; data: Partial<ScheduledTransfer> }>, ScheduledTransfer>();

const [
  requestCreateAchScheduledDeposit,
  receiveCreateAchScheduledDeposit,
  errorCreateAchScheduledDeposit,
] = buildActions({
  REQUEST: REQUEST_CREATE_ACH_SCHEDULED_DEPOSIT,
  RECEIVE: RECEIVE_CREATE_ACH_SCHEDULED_DEPOSIT,
  ERROR: ERROR_CREATE_ACH_SCHEDULED_DEPOSIT,
})<AccountRequestFor<CreateAchScheduledDepositRequest>, ScheduledTransfer>();

const [
  requestCreateAchScheduledWithdrawal,
  receiveCreateAchScheduledWithdrawal,
  errorCreateAchScheduledWithdrawal,
] = buildActions({
  REQUEST: REQUEST_CREATE_ACH_SCHEDULED_WITHDRAWAL,
  RECEIVE: RECEIVE_CREATE_ACH_SCHEDULED_WITHDRAWAL,
  ERROR: ERROR_CREATE_ACH_SCHEDULED_WITHDRAWAL,
})<AccountRequestFor<CreateAchScheduledWithdrawalRequest>, ScheduledTransfer>();

const [
  requestCreateWireScheduledWithdrawal,
  receiveCreateWireScheduledWithdrawal,
  errorCreateWireScheduledWithdrawal,
] = buildActions({
  REQUEST: REQUEST_CREATE_WIRE_SCHEDULED_WITHDRAWAL,
  RECEIVE: RECEIVE_CREATE_WIRE_SCHEDULED_WITHDRAWAL,
  ERROR: ERROR_CREATE_WIRE_SCHEDULED_WITHDRAWAL,
})<AccountRequestFor<CreateWireScheduledWithdrawalRequest>, ScheduledTransfer>();

const [
  requestCreateCheckScheduledWithdrawal,
  receiveCreateCheckScheduledWithdrawal,
  errorCreateCheckScheduledWithdrawal,
] = buildActions({
  REQUEST: REQUEST_CREATE_CHECK_SCHEDULED_WITHDRAWAL,
  RECEIVE: RECEIVE_CREATE_CHECK_SCHEDULED_WITHDRAWAL,
  ERROR: ERROR_CREATE_CHECK_SCHEDULED_WITHDRAWAL,
})<AccountRequestFor<CreateCheckScheduledWithdrawalRequest>, ScheduledTransfer>();

const ScheduledTransferActions = {
  requestScheduledTransfers,
  receiveScheduledTransfers,
  errorScheduledTransfers,
  requestScheduledTransferDetails,
  receiveScheduledTransferDetails,
  errorScheduledTransferDetails,
  requestCancelScheduledTransfer,
  receiveCancelScheduledTransfer,
  receiveUpdateScheduledTransfer,
  errorUpdateScheduledTransfer,
  requestCreateAchScheduledDeposit,
  receiveCreateAchScheduledDeposit,
  errorCreateAchScheduledDeposit,
  requestCreateAchScheduledWithdrawal,
  receiveCreateAchScheduledWithdrawal,
  errorCreateAchScheduledWithdrawal,
  requestCreateWireScheduledWithdrawal,
  receiveCreateWireScheduledWithdrawal,
  errorCreateWireScheduledWithdrawal,
  requestCreateCheckScheduledWithdrawal,
  receiveCreateCheckScheduledWithdrawal,
  errorCreateCheckScheduledWithdrawal,
  requestUpdateScheduledTransfer,
  errorCancelScheduledTransfer,
};

export default ScheduledTransferActions;
